import { Component, Inject, Input, NgModuleRef, OnInit, Type } from '@angular/core';
import { IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { QuickModeModal } from '../../../../modals/quick-mode/quick-mode-modal.component';
import { EmptyComponent } from '../../../empty/empty.component';
import { QuickModeSettings } from '../../../../modals/quick-mode/quick-mode.interfaces';
import { ClickProfileComponent } from '../../../../../modules/traffic-data/click/widgets/profile/profile.component';
import { AffiliateProfileComponent } from '../../../../../modules/affiliates/affiliate/widgets/profile/profile.component';
import { AffiliateTrackersProfileComponent } from '../../../../../modules/affiliates/affiliate-tracker/widgets/profile/profile.component';
import { AdvertiserProfileComponent } from '../../../../../modules/advertisers/advertiser/widgets/profile/profile.component';
import { AffiliateBillingProfileComponent } from '../../../../../modules/affiliates/affiliate-billing/widgets/profile/profile.component';
import { OfferProfileComponent } from '../../../../../modules/traffic-control/offer/widgets/profile/profile.component';
import { DomainProfileComponent } from '../../../../../modules/settings/tracking-domains/tracking-domain/widgets/profile/profile.component';
import { IncidentProfileComponent } from '../../../../../modules/notifications/incident/widgets/profile/profile.component';
import { PayoutTypeProfileComponent } from '../../../../../modules/settings/payout-types/payout-type/widgets/profile/profile.component';
import { RevenueTypeProfileComponent } from '../../../../../modules/settings/revenue-types/revenue-type/widgets/profile/profile.component';
import { AdvertiserBrandProfileComponent } from '../../../../../modules/settings/advertiser-brands/advertiser-brand/widgets/profile/profile.component';
import { AffiliateTrackersGlobalProfileComponent } from '../../../../../modules/affiliates/affiliate-tracker-global/widgets/profile/profile.component';
import { RbacPermissionsConstant } from '../../../../services/rbac/rbac-permissions.constant';
import { ConversionProfileComponent } from '../../../../../modules/traffic-data/conversions/conversion/widgets/profile/profile.component';
import { GoalProfileComponent } from '../../../../../modules/settings/offer/offer-goal/widgets/profile/profile.component';
import { FinanceInvoiceProfileComponent } from '../../../../../modules/finance-tools/finance-invoices/widgets/profile/profile.component';
import { FinancePaymentProfileComponent } from '../../../../../modules/finance-tools/finance-payments/widgets/profile/profile.component';
import { ReferralBusinessModelProfileWidgetComponent } from '../../../../../modules/settings/referral-business-models/referral-business-model/widget/referral-business-model-profile-widget/referral-business-model-profile-widget.component';

@Component({
  selector: 'gtd-view-mode',
  templateUrl: './view-mode.component.html',
})
export class ViewModeComponent implements OnInit {
  @Input() rbacProperty: string;
  @Input() data: number;
  @Input() link: string[] | string;
  @Input() type: string;
  @Input() dataLinkName: {
    id: number;
    name: string;
  };

  public settings: QuickModeSettings | null = null;
  public id: number;

  constructor(@Inject(IMODALS_SERVICE) private modalsService: IModalsService, private moduleRef: NgModuleRef<any>) {}

  ngOnInit(): void {
    this.id = this.data || this.dataLinkName?.id;
    this.settings = getSettings(this.id, this.type);
  }

  openQuickViewModal(): void {
    const { id, link, settings, rbacProperty, moduleRef } = this;
    this.modalsService.open(
      QuickModeModal,
      {
        id,
        link,
        settings,
        rbacProperty,
      },
      moduleRef
    );
  }
}

const getSettings = (id: number, type: string): QuickModeSettings => {
  switch (type) {
    case 'offer_id': {
      return settingHelper(type, OfferProfileComponent, { offer_id: id }, RbacPermissionsConstant.WIDGETS_OFFER_PROFILE);
    }
    case 'goal_id': {
      return settingHelper(type, GoalProfileComponent, { goal_id: id }, RbacPermissionsConstant.WIDGETS_GOAL_PROFILE);
    }
    case 'click_id': {
      return settingHelper(type, ClickProfileComponent, { click_id: id }, RbacPermissionsConstant.WIDGETS_CLICK_PROFILE);
    }
    case 'affiliate_id': {
      return settingHelper(type, AffiliateProfileComponent, { affiliate_id: id }, RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE);
    }
    case 'affiliate_tracker_id': {
      return settingHelper(
        type,
        AffiliateTrackersProfileComponent,
        { affiliate_tracker_id: id },
        RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE
      );
    }
    case 'advertiser_id': {
      return settingHelper(type, AdvertiserProfileComponent, { advertiser_id: id }, RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE);
    }
    case 'invoice_id': {
      return settingHelper(
        type,
        AffiliateBillingProfileComponent,
        { invoice_id: id },
        RbacPermissionsConstant.WIDGETS_AFFILIATE_INVOICE_PROFILE
      );
    }
    case 'finance_invoice_id': {
      return settingHelper(type, FinanceInvoiceProfileComponent, { invoice_id: id }, RbacPermissionsConstant.PAGES_PROFILE_INVOICE);
    }
    case 'finance_payment_id': {
      return settingHelper(type, FinancePaymentProfileComponent, { payment_id: id }, RbacPermissionsConstant.PAGES_PROFILE_PAYMENT);
    }
    case 'tracking_domain_id': {
      return settingHelper(
        type,
        DomainProfileComponent,
        { tracking_domain_id: id },
        RbacPermissionsConstant.WIDGETS_TRACKING_DOMAIN_PROFILE
      );
    }
    case 'incident_id': {
      return settingHelper(type, IncidentProfileComponent, { id }, RbacPermissionsConstant.WIDGETS_INCIDENTS_PROFILE);
    }
    case 'payout_model':
    case 'payout_model_id': {
      return settingHelper(
        type,
        PayoutTypeProfileComponent,
        { payout_model_id: id },
        RbacPermissionsConstant.WIDGETS_PAYOUT_BUSINESS_MODEL
      );
    }
    case 'revenue_model':
    case 'revenue_model_id': {
      return settingHelper(
        type,
        RevenueTypeProfileComponent,
        { revenue_model_id: id },
        RbacPermissionsConstant.WIDGETS_REVENUE_BUSINESS_MODEL
      );
    }
    case 'advertiser_brand_id': {
      return settingHelper(
        type,
        AdvertiserBrandProfileComponent,
        { brand_id: id },
        RbacPermissionsConstant.WIDGETS_ADVERTISER_BRAND_PROFILE
      );
    }
    case 'global_postback_id': {
      return settingHelper(
        type,
        AffiliateTrackersGlobalProfileComponent,
        { global_postback_id: id },
        RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE
      );
    }
    case 'conversion_id': {
      return settingHelper(type, ConversionProfileComponent, { goal_item_id: id }, RbacPermissionsConstant.WIDGETS_CONVERION_PROFILE);
    }
    case 'referral_payout_model':
    case 'referral_payout_model_id': {
      return settingHelper(
        type,
        ReferralBusinessModelProfileWidgetComponent,
        { business_model_id: id },
        RbacPermissionsConstant.WIDGETS_REFERRAL_PAYOUT_BUSINESS_MODEL
      );
    }
    default: {
      return settingHelper('-', EmptyComponent, null, 'Quick View');
    }
  }
};

const settingHelper = (
  key: string,
  component: Type<any>,
  settings: {
    [key: string]: any;
  } | null,
  rbacViewProp: string,
  title = $localize`:@@common.basic_information:Basic Information`,
  tabsTitle = '',
  customClass = '-quick-view'
) => {
  return {
    title,
    key,
    tabs: [
      {
        title: tabsTitle,
        component,
        settings: settings ? { autoInit: true, settings, customClass } : { desc: 'Empty', icon: 'box', noBorder: true },
      },
    ],
    rbacViewProp,
  };
};
